import { cn } from '@/app/lib/utils'
import './typography.css'

interface TypographyProps {
  children: React.ReactNode
  className?: string
}

// Display Components
export function DisplayHero({ children, className }: TypographyProps) {
  return (
    <h1 className={cn('text-hero', className)}>
      {children}
    </h1>
  )
}

export function DisplayLarge({ children, className }: TypographyProps) {
  return (
    <h1 className={cn('text-display-lg', className)}>
      {children}
    </h1>
  )
}

export function DisplayMedium({ children, className }: TypographyProps) {
  return (
    <h2 className={cn('text-display-md', className)}>
      {children}
    </h2>
  )
}

export function DisplaySmall({ children, className }: TypographyProps) {
  return (
    <h2 className={cn('text-display-sm', className)}>
      {children}
    </h2>
  )
}

// Heading Components
export function H1({ children, className }: TypographyProps) {
  return (
    <h1 className={cn('text-h1', className)}>
      {children}
    </h1>
  )
}

export function H2({ children, className }: TypographyProps) {
  return (
    <h2 className={cn('text-h2', className)}>
      {children}
    </h2>
  )
}

export function H3({ children, className }: TypographyProps) {
  return (
    <h3 className={cn('text-h3', className)}>
      {children}
    </h3>
  )
}

export function H4({ children, className }: TypographyProps) {
  return (
    <h4 className={cn('text-h4', className)}>
      {children}
    </h4>
  )
}

export function H5({ children, className }: TypographyProps) {
  return (
    <h5 className={cn('text-h5', className)}>
      {children}
    </h5>
  )
}

export function H6({ children, className }: TypographyProps) {
  return (
    <h6 className={cn('text-h6', className)}>
      {children}
    </h6>
  )
}

// Body Text Components
export function BodyLarge({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body-lg', className)}>
      {children}
    </p>
  )
}

export function Body({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body', className)}>
      {children}
    </p>
  )
}

export function BodySmall({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body-sm', className)}>
      {children}
    </p>
  )
}

export function BodyExtraSmall({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body-xs', className)}>
      {children}
    </p>
  )
}

export function BodyEllipsis({ children, className }: TypographyProps) {
  return (
    <p className={cn('text-body-ellipsis', className)}>
      {children}
    </p>
  )
}

// Label & Caption Components
export function Label({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-label', className)}>
      {children}
    </span>
  )
}

export function Caption({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-caption', className)}>
      {children}
    </span>
  )
}

// Button Typography Components
export function ButtonLarge({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-button-lg', className)}>
      {children}
    </span>
  )
}

export function Button({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-button', className)}>
      {children}
    </span>
  )
}

export function ButtonSmall({ children, className }: TypographyProps) {
  return (
    <span className={cn('text-button-sm', className)}>
      {children}
    </span>
  )
}

